import { HTTPClient } from "@/common/HTTPClient";

export class AskCenAiClient {
  constructor(private httpClient: HTTPClient) {}

  public async chat(params: { message: string; sessionId?: string | null; companyId?: number | null }): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/api/v1/ask/chat",
      method: "POST",
      data: {
        message: params.message,
        session_id: params.sessionId || null,
        company_id: params.companyId || null,
      },
    });
    return data;
  }
}
